import { ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router";

import { Button, EmptyState, PageHeader, Skeleton, StatusMessage } from "@ceedero/ui";

import { useCloudLibrary } from "@/cloud/hooks/use-cloud-pull";
import { AppPage } from "@/components/app-page";
import { useTranslation } from "@/localization/hooks/use-translation";
import { selectLiveProjects } from "@/music-catalog/utils/catalog-view";
import { ROUTES } from "@/navigation/constants/routes";
import { ProjectVersionHistory } from "@/project-history/components/project-version-history";

export const ProjectHistoryPage = () => {
  const { t } = useTranslation();
  const { desktopProjectId } = useParams();
  const library = useCloudLibrary();
  const project = library.data
    ? selectLiveProjects(library.data.projects).find(
        (candidate) => candidate.desktopProjectId === desktopProjectId,
      )
    : undefined;
  return (
    <AppPage
      scrollContentClassName="overflow-clip"
      header={
        <PageHeader
          title={t("history.title")}
          description={project?.title}
          actions={
            <Button asChild variant="outline">
              <Link
                to={
                  desktopProjectId
                    ? `${ROUTES.catalog}/${encodeURIComponent(desktopProjectId)}`
                    : ROUTES.catalog
                }
              >
                <ArrowLeft aria-hidden />
                {t("history.backToProject")}
              </Link>
            </Button>
          }
        />
      }
    >
      {library.isPending && <Skeleton className="h-40 w-full" />}
      {library.isError && <StatusMessage tone="error">{t("catalog.unavailable")}</StatusMessage>}
      {library.data && !project && (
        <EmptyState
          title={t("project.notFound.title")}
          description={t("project.notFound.description")}
        />
      )}
      {project && (
        <ProjectVersionHistory
          key={project.desktopProjectId}
          projectId={project.desktopProjectId}
          title={project.title}
        />
      )}
    </AppPage>
  );
};
